<template lang="pug">
.waiter-registration-pdf-modal.pageout(v-show="isShow" ref="printTarget")
  .title
    span HitomeQコネクト ID通知書
  .message
    div HitomeQコネクトの登録用ID・パスワードを下記のとおり発行いたしました。
    div HitomeQコネクトの登録手順は、別紙「HitomeQコネクト登録方法」をご参照ください。
  .registration
    table
      tbody
        tr
          td.key 入所申込者名
          td.value {{ waiter.name }}
        tr
          td.key 施設ID
          td.value {{ waiter.facilityId }}
        tr
          td.key 利用者ID
          td.value {{ waiter.id }}
        tr
          td.key パスワード
          td.value {{ waiter.password }}
        tr
          td.key 登録用QRコード
          td.qr-code-value
            .d-flex
              img.qr-code-image.mr-2(:src="qrCodeDataUrl")
              .description.mb-2
                span LINEアプリの友だち追加から、
                br
                span このQRコードを読んでください。
                br
                span ユーザー登録ページが開きますので、
                br
                span ご自身の情報を入力して登録してください。
  .caution
    div 注１）重要な情報となりますので、厳重に管理してください。
    div 注２）もし紛失等によりパスワード変更・再発行を希望される場合は、その他もしくはメッセージよりHitomeQコネクトへご連絡ください。
    div 注３）登録後にその他メニューのユーザー登録情報変更から、登録先と登録内容をご確認ください。
  .end-message
    span 以上

  b-modal(ref="modal" size="xl" no-close-on-backdrop=true no-close-on-esc=true hide-footer @close="onClose()")
    .registration-pdf-modal-body
      object.pdf(:data="pdfUrl" type="application/pdf")
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import ConvertElement2Pdf, { PsfMakeOrientation, PdfMakePage, PdfMakeOutputType } from "@/commons/utils/ConvertElement2Pdf";

import { WaitersGetModel } from "@/commons/services/Waiters";

// @types/qrcodeを使用することimportはできるようになるが、npm run serveでコンパイルエラーが発生するので使用しない
// そのため、requireでインポートする
const QRCode = require("qrcode");

/**
 * ID通知書PDFモーダルコンポーネント
 */
@Component
export default class RegistrationGuidePdfModal extends Vue {
  /** 印刷対象の登録情報 */
  waiter: WaitersGetModel | any = {};
  /** 印刷時のみ表示したいので表示フラグを持つ */
  isShow: boolean = false;
  /** PDF URL */
  pdfUrl: string = "";
  /** QRコード DataURL */
  qrCodeDataUrl: string = "";

  /**
   * ### PDFを開く
   *
   * -渡された情報でtemplateを更新し、ブラウザの印刷プレビューを表示する
   */
  public async show(waiter: WaitersGetModel): Promise<void> {
    this.isShow = true;
    this.waiter = waiter;
    this.qrCodeDataUrl = await this.createQrCodeDataUrl(waiter);

    await this.$nextTick();

    const pdf: Blob = await this.createPdf();
    this.isShow = false;

    // PDFをモーダルで表示
    this.pdfUrl = window.URL.createObjectURL(pdf);
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * ### QRコードのデータURLを作成する
   */
  public async createQrCodeDataUrl(waiter: WaitersGetModel): Promise<string> {
    const dataText: string = `${process.env.VUE_APP_REGISTER_FAMILY_LIFF_URL}?facilityId=${waiter.facilityId}&residentId=${waiter.id}&password=${waiter.password}`;
    const qrCodeDataUrl: string = await QRCode.toDataURL(dataText);

    return qrCodeDataUrl;
  }

  /**
   * ### PDFを作成する
   */
  public async createPdf(): Promise<Blob> {
    const converter: ConvertElement2Pdf = new ConvertElement2Pdf();
    const pdf: Blob = await converter.createPdfFromHtml(
      this.$refs.printTarget,
      "HitomeQコネクト ID通知書",
      PsfMakeOrientation.PORTRAIT,
      PdfMakePage.A4,
      false,
      PdfMakeOutputType.BLOB
    );

    return pdf;
  }

  /**
   * ### モーダルクローズイベント
   */
  public onClose(): void {
    // メモリ上に確保されたobjectUrlを開放する
    URL.revokeObjectURL(this.pdfUrl);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";

.waiter-registration-pdf-modal {
  // A4用紙相当のサイズを取る
  width: 159mm;
  height: 209mm;
  padding: 10mm;

  .title {
    text-align: center;
    @include bold-font(18px);
    margin-bottom: 40px;
  }
  .message {
    div {
      @include font(12px);
      margin-bottom: 10px;
    }
    margin-bottom: 30px;
  }
  .registration {
    @include font(16px);
    margin-left: auto;
    margin-right: auto;

    table {
      border: 1px solid #000;

      td {
        padding: 12px 8px;
        border: 1px solid #000;
      }
      .key {
        width: 140px;
      }
      .value {
        width: 380px;
        font-family: "Courier New", monospace;
      }
      .qr-code-value {
        width: 380px;

        .qr-code-image {
          width: 80px;
          height: 80px;
        }
        .description {
          font-size: 12px;
        }
      }
    }
    margin-bottom: 40px;
  }
  .caution {
    div {
      @include font(10px);
      margin-bottom: 10px;
    }
    margin-bottom: 30px;
  }
  .end-message {
    @include font(12px);
    text-align: right;
  }
}

// 画面の見えないところに要素を配置する
.pageout {
  position: fixed;
  z-index: -100;
}
</style>
